var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReplay = function SvgReplay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m12.041 23.053 3.058 5.985C19.394 18.74 29.557 11.5 41.414 11.5c15.74 0 28.5 12.76 28.5 28.5s-12.76 28.5-28.5 28.5-28.5-12.76-28.5-28.5a1 1 0 1 1 2 0c0 14.636 11.865 26.5 26.5 26.5s26.5-11.864 26.5-26.5-11.864-26.5-26.5-26.5c-10.887 0-20.242 6.566-24.32 15.955l5.711-2.917a1 1 0 0 1 .91 1.78L15.7 32.414a1 1 0 0 1-1.345-.435l-4.095-8.015a1 1 0 1 1 1.781-.91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m51.987 41.096-15-8.66v17.32z"
  })));
};
export default SvgReplay;